var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/wallet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6663 7.9974V11.3307C14.6663 13.3307 13.333 14.6641 11.333 14.6641H4.66634C2.66634 14.6641 1.33301 13.3307 1.33301 11.3307V7.9974C1.33301 6.18406 2.42634 4.91739 4.12634 4.70406C4.29967 4.67739 4.47967 4.66406 4.66634 4.66406H11.333C11.5063 4.66406 11.673 4.67072 11.833 4.69739C13.553 4.89739 14.6663 6.17073 14.6663 7.9974Z",
    stroke: "#949DA6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.8346 4.7026C11.6746 4.67594 11.5079 4.66928 11.3346 4.66928H4.66793C4.48126 4.66928 4.30126 4.68261 4.12793 4.70928C4.22126 4.52261 4.3546 4.34928 4.5146 4.18928L6.68126 2.01594C7.5946 1.10927 9.0746 1.10927 9.98793 2.01594L11.1546 3.19595C11.5813 3.61595 11.8079 4.14927 11.8346 4.7026Z",
    stroke: "#949DA6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.6663 8.33594H12.6663C11.933 8.33594 11.333 8.93594 11.333 9.66927C11.333 10.4026 11.933 11.0026 12.6663 11.0026H14.6663",
    stroke: "#949DA6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/payment_icon.6d8c6f791f12f86c659ebd6f4681f28e.svg";
export { ForwardRef as ReactComponent };